"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.requestAction = exports.updateRequest = exports.receiveRequest = exports.loadRequest = exports.failRequest = exports.clearRequest = exports.cancelRequest = void 0;
const Keys_1 = require("./Keys");
const Utils_1 = require("./Utils");
const defaultAction = (type, id, meta) => ({
    type: (0, Utils_1.createRequestActionType)(type, id),
    meta,
});
const cancelRequest = (id, meta) => defaultAction(Keys_1.RequestActionType.Cancel, id, meta);
exports.cancelRequest = cancelRequest;
const clearRequest = (id, meta) => defaultAction(Keys_1.RequestActionType.Clear, id, meta);
exports.clearRequest = clearRequest;
const failRequest = (id, payload, meta) => ({
    ...defaultAction(Keys_1.RequestActionType.Fail, id, meta),
    payload,
});
exports.failRequest = failRequest;
const loadRequest = (id, meta) => defaultAction(Keys_1.RequestActionType.Load, id, meta);
exports.loadRequest = loadRequest;
const receiveRequest = (id, payload, meta) => ({
    ...defaultAction(Keys_1.RequestActionType.Receive, id, meta),
    payload,
});
exports.receiveRequest = receiveRequest;
const updateRequest = (id, meta) => {
    const payload = defaultAction(Keys_1.RequestActionType.Load, id, meta);
    return {
        ...payload,
        meta: Object.assign(payload.meta || {}, {
            update: true,
        }),
    };
};
exports.updateRequest = updateRequest;
exports.requestAction = {
    cancel: exports.cancelRequest,
    clear: exports.clearRequest,
    fail: exports.failRequest,
    load: exports.loadRequest,
    receive: exports.receiveRequest,
    update: exports.updateRequest,
};
